import React from 'react';
import { GenericReportingDropdowns } from '../../containers/GenericReportingDropdowns';
import UsernameSearchInput from "../../containers/Influencer/UsernameSearchInput";
import DropdownContainer from '../../containers/DropdownContainer';

const InfluencerContentPageDropdowns = () => {
  return (
      <GenericReportingDropdowns
          includeDateRange={true}
          includeRegion={false}
          includeTooltips={false}
          includeTitles={true}
          extraDropdowns={
            [
              <DropdownContainer dropdown_name="influencer_unique_labels" />,
              <DropdownContainer dropdown_name="influencer_platforms" />,
              <UsernameSearchInput />,
            ]
          }
        />
  );
};

export default InfluencerContentPageDropdowns;